export enum WorkflowType {
  SingleHotelWorkflow = 'HotelWorkflow',
  ExtraServiceWorkflow = 'ExtraServiceWorkflow',
  RebookingWorkflow = 'RebookingWorkflow',
  VoucherWorkflow = 'VoucherWorkflow',
  PackageWorkflow = 'PackageWorkflow',
  MMBWorkflow = 'MMBWorkflow'
}
